import React, {Component} from 'react';
import {func, instanceOf, string} from 'prop-types';
import moment from 'moment';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import DayPicker from '../DayPicker';
import styles from './CalendarPopout.css';

export const FROM_DATE = 'fromDate';
export const THRU_DATE = 'thruDate';

export const FROM_TEXT = 'fromText';
export const THRU_TEXT = 'thruText';

const dateKeyToTextKey = {
  [FROM_DATE]: FROM_TEXT,
  [THRU_DATE]: THRU_TEXT,
};

const DATE_PLACEHOLDER = 'MM/DD/YYYY';

export class CalendarPopout extends Component {
  static propTypes = {
    onDateChange: func.isRequired,
    onOutsideClick: func.isRequired,
    fromDate: instanceOf(Date),
    thruDate: instanceOf(Date),
    fromString: string,
    thruString: string,
  };

  static defaultProps = {
    fromString: 'From',
    thruString: 'Thru',
  };

  constructor(props) {
    super(props);

    const {fromDate, thruDate} = this.props;
    const fromMoment = moment(fromDate || '');
    const thruMoment = moment(thruDate || '');

    this.state = {
      selected: FROM_DATE,
      fromText: fromMoment.isValid() ? fromMoment.format(DATE_PLACEHOLDER) : '',
      thruText: thruMoment.isValid() ? thruMoment.format(DATE_PLACEHOLDER) : '',
    };
  }
  setDateText = (dateField , text) => {
    const textField = dateKeyToTextKey[dateField];
    this.setState({
      [textField]: text,
    });
  }
  dateTextSetter = dateField => ({target: {value: text}}) => this.setDateText(dateField , text);
  selectedDays = (day) => {
    const fromDay = moment(this.props.fromDate);
    const thruDay = moment(this.props.thruDate);

    if (fromDay.isSame(day, 'day')) {
      return true;
    }

    if (thruDay.isSame(day, 'day')) {
      return true;
    }

    if (fromDay.isValid() && thruDay.isValid()) {
      return moment(day).isBetween(fromDay, thruDay);
    }

    return false;
  }
  setDay = (day) => {
    const fieldName = this.state.selected;
    const momentDate = moment(day);
    const newDate = fieldName === FROM_DATE ? momentDate.startOf('day') : momentDate.endOf('day');
    const newDateText = newDate.format(DATE_PLACEHOLDER);
    const newDateValue = newDate.toDate();
    const currentDate = this.props[fieldName] && new Date(this.props[fieldName]);
    this.setDateText(fieldName, newDateText);

    if (!currentDate || currentDate.getTime() !== newDateValue.getTime()) {
      this.props.onDateChange({
        fromDate: this.props.fromDate,
        thruDate: this.props.thruDate,
        [fieldName]: newDateValue,
      });
    }
  }
  onDayInputBlur = fieldName => ({target: {value: text}}) => {
    const newText = text.trim();
    if ((!this.props[fieldName] && newText === '')) {
        return;
    } else if (newText === '') {
      this.props.onDateChange({
        fromDate: this.props.fromDate,
        thruDate: this.props.thruDate,
        [fieldName]: null,
      });
      return;
    }

    const date = moment(text, DATE_PLACEHOLDER);

    if (date.isValid()) {
      const newDateValue = fieldName === FROM_DATE ? date.startOf('day').toDate() : date.endOf('day').toDate();
      const currentDate = this.props[fieldName] && new Date(this.props[fieldName]);

      if (!currentDate || currentDate.getTime() !== newDateValue.getTime()) {
        this.props.onDateChange({
          fromDate: this.props.fromDate,
          thruDate: this.props.thruDate,
          [fieldName]: newDateValue,
        });
      }
    }
  }
  handleClickOutside = () => {
    this.props.onOutsideClick();
  }
  setSelected = selected => () => this.setState({selected});
  render() {
    const {selected, fromText, thruText} = this.state;
    const {fromString, thruString, fromDate, thruDate} = this.props;
    const initialMonth = fromDate !== null ? new Date(fromDate) : (thruDate !== null ? new Date(thruDate) : new Date());
    const fromLabelStyles = classNames({
      [styles.activeDayLabel]: selected === FROM_DATE,
      [styles.baseDayLabel]: selected !== FROM_DATE,
    });
    const thruLabelStyles = classNames({
      [styles.activeDayLabel]: selected === THRU_DATE,
      [styles.baseDayLabel]: selected !== THRU_DATE,
    });

    return (
      <div className={styles.container}>
        <div>
          <label className={fromLabelStyles}>
            <h5>{fromString}</h5>
            <input
              type="text"
              value={fromText}
              placeholder={DATE_PLACEHOLDER}
              onFocus={this.setSelected(FROM_DATE)}
              onChange={this.dateTextSetter(FROM_DATE)}
              onBlur={this.onDayInputBlur(FROM_DATE)}
            />
          </label>
          <label className={thruLabelStyles}>
            <h5>{thruString}</h5>
            <input
              type="text"
              value={thruText}
              placeholder={DATE_PLACEHOLDER}
              onFocus={this.setSelected(THRU_DATE)}
              onChange={this.dateTextSetter(THRU_DATE)}
              onBlur={this.onDayInputBlur(THRU_DATE)}
            />
          </label>
        </div>
        <DayPicker initialMonth={initialMonth} selectedDays={this.selectedDays} onDayClick={this.setDay} />
      </div>
    );
  }
}

export default onClickOutside(CalendarPopout);
